import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListItemModule } from '../list-item/list-item.module';
import { PipesModule } from '../pipes/pipes.module';
import { PackageFilterModalComponent } from './package-filter-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomInputGroupModule } from '../custom-input-group/custom-input-group.module';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { PhoneInputModule } from '../phone-input/phone-input.module';



@NgModule({
  declarations: [PackageFilterModalComponent],
  imports: [
    CommonModule, PipesModule, ListItemModule, FormsModule, ReactiveFormsModule, FormInputErrorModule, CustomInputGroupModule, PhoneInputModule,
  ],
  exports: [
    PackageFilterModalComponent
  ],
})
export class PackageFilterModalModule { }
